import camelcaseKeys from 'camelcase-keys';
/*
const inventoryStatusCodes = {
   isInStock: -1,
   isLowInventory: 1,
   isSoldOut: 3,
  };
*/
const inventoryStatusCodesMap = new Map();
inventoryStatusCodesMap.set(-1, 'inStock');
inventoryStatusCodesMap.set(1, 'lowInventory');
inventoryStatusCodesMap.set(3, 'soldOut');
const transformLegacyInventoryResponse = (response, meta, arg) => {
    var _a;
    const data = camelcaseKeys(response, { deep: true });
    const modelsStock = data === null || data === void 0 ? void 0 : data.modelsStock;
    if (Array.isArray(modelsStock) && modelsStock.length) {
        return (_a = arg === null || arg === void 0 ? void 0 : arg.transmissions) === null || _a === void 0 ? void 0 : _a.map(transmission => {
            var _a, _b;
            const inventory = modelsStock.find(s => (s === null || s === void 0 ? void 0 : s.modelCode) === (transmission === null || transmission === void 0 ? void 0 : transmission.modelCode));
            const statusId = (_b = (_a = inventory === null || inventory === void 0 ? void 0 : inventory.inventoryStatus) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0;
            return {
                modelCode: transmission === null || transmission === void 0 ? void 0 : transmission.modelCode,
                transmissionKey: (transmission === null || transmission === void 0 ? void 0 : transmission.transmissionKey) || '',
                trimKey: transmission === null || transmission === void 0 ? void 0 : transmission.trimKey,
                inventoryStatus: inventoryStatusCodesMap.get(statusId),
            };
        });
    }
    return [];
};
export default transformLegacyInventoryResponse;
